export interface GraphQLResult {
  __typename: string;
}

export type ValueOfTypename<T extends GraphQLResult> = T['__typename'];

export type OfType<Result extends GraphQLResult, Typename extends ValueOfTypename<Result>> = Extract<
  Result,
  { __typename: Typename }
>;

export function isType<Result extends GraphQLResult, Typename extends ValueOfTypename<Result>>(
  result: Result | undefined | null,
  typename: Typename,
): result is OfType<NonNullable<Result>, Typename> {
  return result?.__typename === typename;
}
